(function () {
  'use strict';

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getProductTitle() {
    var breadcrumb = document.querySelector('[data-tz-breadcrumb][data-tz-product-title]');
    if (breadcrumb && breadcrumb.dataset.tzProductTitle) {
      return breadcrumb.dataset.tzProductTitle.trim();
    }

    var heading = document.querySelector('h1, .product__title, [class*="product-title"], [class*="tz-title"]');
    return heading ? heading.textContent.trim() : '';
  }

  function cleanText(text, title) {
    if (!title || !text || text.indexOf(title) === -1) return text;

    var escaped = escapeRegExp(title);
    return text
      .replace(new RegExp('(This item\\s*:?\\s*)' + escaped + '\\s*([—-]\\s*)?', 'gi'), '$1')
      .replace(new RegExp('(Selected\\s*:?\\s*)' + escaped + '\\s*([—-]\\s*)?', 'gi'), '$1')
      .replace(new RegExp('(Option\\s*:?\\s*)' + escaped + '\\s*([—-]\\s*)?', 'gi'), '$1')
      .replace(new RegExp('^\\s*' + escaped + '\\s*([—-]\\s*)', 'gi'), '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function cleanScopedText(root, title) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf(title) === -1) {
          return NodeFilter.FILTER_REJECT;
        }

        var parent = node.parentElement;
        if (!parent || parent.closest('h1, [aria-current="page"], .product__title, [class*="product-title"], [class*="tz-title"]')) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var cleaned = cleanText(textNode.nodeValue, title);
      if (cleaned && cleaned !== textNode.nodeValue.trim()) {
        textNode.nodeValue = cleaned;
      }
    });
  }

  function normalizeVariantAndBundleLabels() {
    var title = getProductTitle();
    if (!title) return;

    var scopes = document.querySelectorAll([
      '[data-tz-variant-options]',
      '[class*="variant"]',
      '[class*="Variant"]',
      '[class*="swatch"]',
      '[class*="Swatch"]',
      '[class*="bundle"]',
      '[class*="Bundle"]',
      '[class*="frequently"]',
      '[class*="Frequently"]'
    ].join(','));

    scopes.forEach(function (scope) {
      cleanScopedText(scope, title);
    });
  }

  function enhanceSavingsLabels() {
    var nodes = document.querySelectorAll('[class*="save"], [class*="Save"], [class*="saving"], [class*="Saving"]');
    nodes.forEach(function (node) {
      if (!/save|saving|rs\.?|₨/i.test(node.textContent || '')) return;
      node.setAttribute('data-tz-savings-enhanced', 'true');
    });
  }

  function boot() {
    normalizeVariantAndBundleLabels();
    enhanceSavingsLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('change', function () {
    window.setTimeout(boot, 50);
  });
})();
